import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import SearchModal from '../components/SearchModal';

const SearchCtx = createContext({ openSearch: () => {}, closeSearch: () => {} });
export const useSearch = () => useContext(SearchCtx);

export const SearchProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openSearch = useCallback(() => setOpen(true), []);
  const closeSearch = useCallback(() => setOpen(false), []);

  // Global keyboard shortcut: Cmd/Ctrl + K
  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setOpen((v) => !v);
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  return (
    <SearchCtx.Provider value={{ openSearch, closeSearch, isOpen: open }}>
      {children}
      <SearchModal open={open} onClose={closeSearch} />
    </SearchCtx.Provider>
  );
};
